import { gql } from '@apollo/client';

export const GET_WORK_SESSIONS_STATE = gql`
  query GetWorkSessionsState {
    workSessionsState {
      currentSession
      sessionTimePassedSeconds
      playTimestamp
    }
  }
`;

export const UPDATE_WORK_SESSIONS_STATE = gql`
  mutation UpdateWorkSessionsState($newState: StoredWorkSessionsStateInput!) {
    updateWorkSessionsState(newState: $newState) {
      currentSession
      sessionTimePassedSeconds
      playTimestamp
    }
  }
`;
